
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/sofar-sounds",
      function () {
        return require("private-next-pages/archive/sofar-sounds.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/sofar-sounds"])
      });
    }
  